var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGpay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_364",
    transform: "scale(0.0344828 0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_364",
    width: 29,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAcCAYAAACdz7SqAAACXElEQVRIDeWVW2sTQRiG+2e88reo9/4C77wU77wVSj2gglTFA60lh6ZUEbW2MVIKVa+KoBAk2yqkOe7mvMe85t1kYmfPNYFe+EGY2W/e731mZmc2CziDWDgDJhJBh8MhHMeBZVmwbdvt85l95tinJmnEQgUkzlBMIk7H8VAoZ07gaYM1casOhP4rUEwwbrt9UAL5nmaNqBX7oKZpzsqb1od5SVBuyzxWKahhh1CCzhMowEGeEtQwDKGdttbPIvTdj3A09W9ucl+niYhOkKcE9b6DXmYV9csX0bpxDZ0HS641Nbfu3sdaOov9z18jcOMhryezElSalWNAT5+DU69gr2hj/YuJgyMbhmEind1AtVrDi5U1ZNY3kMrk8G5rGwSwPXlPJc/JFCOh33bOo95voPDdwtXnAzzKGzBGxkt37mHrww6OjytIZXN4uPwEhU+72M4X8Obt+4n1uImF9vt9qWD1xytc2LyC63uLuPQsjd8Nx11pbvO1q1MOj7DyMoXlx0+hKIe4uXgbqqpJHl5PDkorbbfbUgEfiqqC/K99NPXxQeLWDQaDqa4y2uZ2pwOac6u9EeQpQVutlrcm8XOv10Oj0fTpgzwlKFfA4nlFt9uVdkX4SlAma7WaGJu5rVargR4+qK7rcwFz8vQKCh+UIk3TRu+nEaRPlGs2m65HmDgQSjELy+VyWF1onjWsjYpQKIt43BVFiZy1MOfuUBt0RYRGtJFQivh3x/dTKpVcUx4Obj1/7BPEMWqoTRKxUGHCjwK/rbwGqqq6P/aZO/mtFfqoNjE0yuS0Y/8P9A9u5XDzTICqQQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.e458ea8b3421decc21ffcec359e35a25.svg";
export { ForwardRef as ReactComponent };